import React, { FC } from "react";
import ModalBoxCore from "../../core-components/modal-box/ModalBoxCore";
import ModalHeader from "../../core-components/modal-box/modal-header/ModalHeader";
import ModalBody from "../../core-components/modal-box/modal-body/ModalBody";
import Typography from "@mui/material/Typography";
import ModalFooter from "../../core-components/modal-box/modal-footer/ModalFooter";
import { iReOpenModalProps } from "../../../types/modalBoxType";

import "./reOpenModal.css";

const ReOpenModal: FC<iReOpenModalProps> = ({
	open,
	onClose,
	modalHeaderText,
	reOpenBodyText,
	buttonText,
	variant,
	color,
	fullWidth,
	disabled,
	coreBtnPill,
	onclick,
}) => {
	return (
		<>
			<ModalBoxCore open={open} onClose={onClose} className="reOpenModal">
				<ModalHeader
					modalHeaderText={modalHeaderText}
					closeModal={onClose}
				/>
				<ModalBody>
					<Typography variant="body1">{reOpenBodyText}</Typography>
				</ModalBody>
				<ModalFooter
					buttonText={buttonText}
					variant={variant}
					color={color}
					fullWidth={fullWidth}
					disabled={disabled}
					coreBtnPill={coreBtnPill}
					onclick={onclick}
				/>
			</ModalBoxCore>
		</>
	);
};
export default ReOpenModal;
